export class PageInfo {
  size: number;
  totalElements: number;
  totalPages: number;
  number: number;
}